export const bool = value => {
  if (typeof value === 'boolean') {
    return value ? 'true' : 'false'
  }
  return value
}

export const number = value => (value === 'number' ? value.toString() : value)
